import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import classes from "./EditServices.module.scss";
import Overview from "../components/pricingComponents/Overview";
import useWindowSize from "../hooks/useWindowSize";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from "react-i18next";
import BillingHistory from "../components/table/BillingHistory";
import Preferences from "../components/pricingComponents/Preferences";
import PaymentMethods from "../components/pricingComponents/PaymentMethods";
import Packages from "../components/clientWizard/packages/Packages";
import ContactUsForPayment from "../components/table/ContactUsForPayent";
import PackageSelectorNew from "../components/pricingComponents/PackageSelectorNew";
import { OrgIdContext } from "../store/orgId_context";
import { DDD } from "../lib/ddd/ddd";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ChangePaymentPlan = () => {
  const { width } = useWindowSize();
  const [page, setPage] = useState("overview"); //overview, plans, methods, history, preferences
  const [packages, setPackages] = useState([]);
  const {t} = useTranslation();

  const { isIntegrator, ISVCustomer, sessionInfo, clientType, customerRelation, setCustomerRelationHandler, aboutOrgId, setSessionInfoHandler } = useContext(OrgIdContext);
  const handleChange = (event) => {
    setPage(event.target.value);
  };

  const loadPackages = (service, packageType, clientTypePrecisely="eCommerce") => {
      let args = {Service : service, ClientType : clientType, ClientTypePrecisely : clientTypePrecisely, PackageType : packageType};
      const ddd = new DDD(apiRequestAddress);
      ddd.Rpc_ExecuteExtension("EUeInvoices.ListOfPackages", args).then(res => {
          let data = res?.result?.data;
if(data?.length > 0)setCustomPackages(data);
      })
  }

  const setCustomPackages = (customPackages) => {
    let pkgs = [];
    customPackages.forEach(pkg => {
      if(!pkg.Package__PluginOwnerId) return;
      pkgs.push(pkg);
    });
    setPackages(pkgs);
  }

  useEffect(() => {
    if(ISVCustomer)
      loadPackages("dddinvoices.com", "IEI");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) return;

    // Clean the URL immediately
    window.history.replaceState(null, "", window.location.pathname);
    setPage("plans");

    const ddd = new DDD(apiRequestAddress);
    const maxAttempts = 8;

    const poll = async () => {
      for (let i = 0; i < maxAttempts; i++) {
        if (i > 0) await new Promise((r) => setTimeout(r, 2000));
        try {
          const res = await ddd.Rpc_ExecuteMethod("EUeInvoices.GetStripeSessionStatus", { SessionId: sessionId });
          const status = res?.result?.SubscriptionStatus;
          if (status === "complete" || status === "paid" || status === "Active") break;
        } catch {}
      }
      // Regardless of poll result, invalidate and refresh session
      await ddd.InvalidateSessionExtensions();
      const descRes = await ddd.GetSessionAuthDescribe({ includeExtendedInfo: true });
      if (descRes?.result) setSessionInfoHandler(descRes.result);
    };

    poll();
  }, []);

  const goToOverview = () => {
    setPage("overview");
  }



  return (
    <>
      <Helmet>
        <title>Change payment plan | DDD Invoices</title>
      </Helmet>
      <div className={`d-flex flex-column flex-grow-1 p-4 ${classes.container}`}>
        <div><h5 className={`${classes.title} mb-4`}>{t("Payment & billing")}</h5></div>
        {width > 768 ? ( 
          <div className="d-flex justify-content-between align-items-center ms-3 me-3">
            <div className={`${classes.slideTitle} ${page==="overview" ? classes.titleSelected : ""}`} onClick={() => setPage("overview")}>{t("Overview")}</div>
            <div className={`${classes.slideTitle} ${page==="plans" ? classes.titleSelected : ""}`} onClick={() => setPage("plans")}>{t("Payment plans")}</div>
            {/* <div className={`${classes.slideTitle} ${page==="methods" ? classes.titleSelected : ""}`} onClick={() => setPage("methods")}>{t("Payment methods")}</div> */}
            <div className={`${classes.slideTitle} ${page==="history" ? classes.titleSelected : ""}`} onClick={() => setPage("history")}>{t("Billing history")}</div>
            <div className={`${classes.slideTitle} ${page==="preferences" ? classes.titleSelected : ""}`} onClick={() => setPage("preferences")}>{t("Preferences")}</div>
          </div>
        ):(<>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Menu</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={page}
                label="Menu"
                onChange={handleChange}
              >
                <MenuItem value={"overview"}>{t("Overview")}</MenuItem>
                <MenuItem value={"plans"}>{t("Payment plans")}</MenuItem>
                <MenuItem value={"methods"}>{t("Payment methods")}</MenuItem>
                <MenuItem value={"history"}>{t("Billing history")}</MenuItem>
                <MenuItem value={"preferences"}>{t("Preferences")}</MenuItem>
              </Select>
            </FormControl>
        </>)}
        <div className="flex-grow-1 mt-4">
          {page === "overview"  && <Overview goToPackages={() =>{setPage("plans");}} goToMethods={() =>{setPage("methods");}}/>}
          {page === "history"  && <BillingHistory/>}
          {page === "preferences"  && <Preferences/>}
          {page === "plans2"  && <Packages/>}
          {page === "plans-prod"  && <ContactUsForPayment/>}
          {page === "plans" && packages?.length > 0  && <PackageSelectorNew packages={packages} goToOverview={goToOverview}/>}
          {page === "plans" && packages?.length === 0  && <ContactUsForPayment/>}
          {page === "methods"  && <PaymentMethods/>}
        </div>
      </div>
    </>
  );
};

export default ChangePaymentPlan;
